<template>
  <div class="table-header flex">
    <h4 class="table-title">Check</h4>
    <h4 class="table-title">Monto</h4>
    <h4 class="table-title">Placa</h4>
    <h4 class="table-title">Modelo</h4>
    <h4 class="table-title dspl-none-m dspl-none-sm">Marca</h4>
    <h4 class="table-title dspl-none-m dspl-none-sm">Año</h4>
    <h4 class="table-title dspl-none-m dspl-none-sm">Método de Pago</h4>
    <h4 class="table-title dspl-none-m dspl-none-sm">Estado</h4>
  </div>
</template>

<script>
export default {
  name: 'TableHeader'
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.table-header {
  background-color: $white;
  border-radius: 20px;
  margin: 2rem 0;
}
.table-title {
  text-align: center;
  margin: .75rem 0;
  width: calc(100% / 7);
}
@media screen and (max-width: 60rem) {
  .table-title {
    width: calc(100% / 4)
  }

  h4 {
    font-size: .75rem;
  }
}
</style>
